export default "__VITE_ASSET__CBLd73Sv__"